<template>
    <div>
        <kt-panel>
            <kt-panel-body>
                <form @submit.prevent="edit" id="manual_settlement">
                  <kt-row lg="12" md="12" xs="12">
                      <kt-col lg="3" md="3" xs="12">
                          <kt-form-group>
                              <kt-form-label for="id">
                                  {{ $t('label.settlement_id') }}
                              </kt-form-label>
                              <kt-form-control
                                      id="id"
                                      name="id"
                                      disabled
                                      :value="form_data.id"
                              >
                              </kt-form-control>
                          </kt-form-group>
                      </kt-col>
                      <kt-col lg="3" md="3" xs="12">
                          <kt-form-group>
                              <kt-form-label for="full_name">
                                  {{ $t('label.user_full_name') }}
                              </kt-form-label>
                              <kt-form-control
                                      id="full_name"
                                      name="full_name"
                                      disabled
                                      :value="form_data.full_name"
                              >
                              </kt-form-control>
                          </kt-form-group>
                      </kt-col>
                      <kt-col lg="3" md="3" xs="12">
                          <kt-form-group>
                              <kt-form-label for="gateway_farsi_name">
                                  {{ $t('label.gateway_farsi_name') }}
                              </kt-form-label>
                              <kt-form-control
                                      id="gateway_farsi_name"
                                      name="gateway_farsi_name"
                                      disabled
                                      :value="form_data.gateway_farsi_name"
                              >
                              </kt-form-control>
                          </kt-form-group>
                      </kt-col>
                      <kt-col lg="3" md="3" xs="12">
                          <kt-form-group>
                              <kt-form-label for="gateway_id">
                                  {{ $t('label.gateway_id') }}
                              </kt-form-label>
                              <kt-form-control
                                      id="gateway_id"
                                      name="gateway_id"
                                      disabled
                                      :value="form_data.gateway_id"
                              >
                              </kt-form-control>
                          </kt-form-group>
                      </kt-col>
                  </kt-row>
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-row>
                                <kt-col lg="4" md="4" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="amount">
                                            {{ $t('label.settlement_amount') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="amount"
                                                name="amount"
                                                :disabled="! can_edit_amount"
                                                v-model="form_data.amount"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="4" md="4" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="wage">
                                            {{ $t('label.wage') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="wage"
                                                name="wage"
                                                disabled
                                                :value="form_data.wage"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="4" md="4" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="banking_wage">
                                            {{ $t('label.transfer_paya_wage') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="banking_wage"
                                                name="banking_wage"
                                                disabled
                                                :value="form_data.banking_wage"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>

                            </kt-row>
                            <kt-row>

                                <kt-col lg="4" md="4" xs="12">
                                    <kt-form-group>
                                        <kt-form-label for="wage_bank">
                                            {{ $t('label.banking_wage') }}
                                        </kt-form-label>
                                        <kt-form-control
                                            id="wage_bank"
                                            name="wage_bank"
                                            disabled
                                            :value="form_data.wage_bank"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>

                                <kt-col lg="4" md="4" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="created_at">
                                        {{ $t('label.date_created') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            id="created_at"
                                            name="created_at"
                                            disabled
                                            :value="form_data.created_at"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="4" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="updated_at">
                                        {{ $t('label.date_updated') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            id="updated_at"
                                            name="updated_at"
                                            disabled
                                            :value="form_data.updated_at"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="6" md="6" xs="12" v-if="form_data.type != 2">
                                <kt-form-group>
                                    <kt-form-label for="website_address">
                                        {{ $t('label.website_address') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            id="website_address"
                                            name="website_address"
                                            dir="ltr"
                                            disabled
                                            :value="form_data.website_address"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>

                                <kt-col lg="6" md="6" xs="12">
                                    <kt-form-group v-if="form_data.type == 6">
                                        <kt-form-label for="wallet_hashid">
                                            {{ $t('label.wallet_hashid') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="wallet_hashid"
                                                name="wallet_hashid"
                                                disabled
                                                :value="form_data.wallet_hashid"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                    <kt-form-group v-else>
                                        <kt-form-label for="sheba_number">
                                            {{ $t('label.sheba_number') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                id="sheba_number"
                                                name="sheba_number"
                                                disabled
                                                :value="form_data.sheba_number"
                                        >
                                        </kt-form-control>
                                    </kt-form-group>
                                </kt-col>

                            </kt-row>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12" id="settings_form">
                        <kt-row>



                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="description">
                                        {{ $t('label.description') }}
                                    </kt-form-label>
                                    <textarea
                                            id="description"
                                            name="description"
                                            class="form-control"
                                            rows="2"
                                            v-model="form_data.description"
                                    >
                                </textarea>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="tracking_code">
                                        {{ $t('label.tracking_code') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            id="tracking_code"
                                            name="tracking_code"
                                            v-model="form_data.tracking_code"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('label.change_status') }}
                                    </kt-form-label>
                                    <kt-form-select size="3" id="status" name="status" v-model="form_data.status">
                                        <option
                                                v-bind:key="index"
                                                v-for="(status, index) in statuses"
                                                v-bind:value="status.id"
                                                :selected="form_data.value"
                                        >
                                            {{ status.value }}
                                        </option>
                                    </kt-form-select>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="12" md="12" xs="12">
                                <div v-if="form_data.next_id != 0" class="position-absolute">
                                    <a
                                            class="btn btn-md btn-info btn-wide"
                                            @click="change_location(form_data.next_id)"
                                            style="color: #fff!important; cursor: pointer"
                                    >
                                        <i class="fa fa-arrow-right" aria-hidden="true"></i> {{ $t('label.next') }}
                                    </a>
                                </div>
                                <kt-form-action style="text-align: end">
                                    <button  class="btn btn-md btn-success btn-wide" type="submit" id="save_btn">
                                        {{ $t('btn.update') }}
                                    </button>
                                </kt-form-action>
                            </kt-col>
                        </kt-row>
                    </kt-col>
                    </kt-row>
                </form>
            </kt-panel-body>
        </kt-panel>
        <kt-panel v-if="form_data.details && form_data.details.length != 0">
            <kt-panel-body>
                <h5 class="mb-4">{{ $t('label.payment_details') }}</h5>
                <table class="table table-striped" style="font-size: 0.89rem;">
                    <thead>
                    <tr>
                        <td>{{ $t('label.amount') + ' (' + $t('currency.rial') + ')' }}</td>
                        <td v-if="form_data.type == 6">{{ $t('label.wallet_hashid') }}</td>
                        <td v-else>{{ $t('label.sheba_number') }}</td>
                        <td>{{ $t('label.payee_name') }}</td>
                        <td>{{ $t('label.bank_reference') }}</td>
                        <td>{{ $t('label.status') }}</td>
                        <td>{{ $t('datatable.actions') }}</td>
                    </tr>
                    </thead>
                    <tbody style="white-space: nowrap;">
                    <tr
                            v-bind:key="index"
                            v-for="(detail, index) in form_data.details"
                    >
                        <td>{{ detail.amount }}</td>
                        <td v-if="form_data.type == 6">{{ form_data.wallet_hashid }}</td>
                        <td v-else>{{ detail.sheba_number }}</td>
                        <td>{{ detail.full_name }}</td>
                        <td>{{ detail.bank_reference }}</td>
                        <td>
                            <div :class="getStatusColor(detail.status)">{{ getStatusStr(detail.status) }}</div>
                        </td>
                        <td>
                            <div class="dropdown">
                                <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm"
                                        data-toggle="dropdown" data-target="#myModal">
                                    <i class="fa fa-cog"></i>
                                </button>
                                <div class="dropdown-menu">
                                    <h5 class="dropdown-header">{{ $t('label.change_status_to') }}</h5>
                                    <button
                                            id="change_status_btn"
                                            v-for="(status, index) in statuses"
                                            @click="changeDetailStatus(detail.id, status.id)"
                                            class="dropdown-item"
                                            v-bind:key="index"
                                    >
                                        {{ status.value }}
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </kt-panel-body>
        </kt-panel>
    </div>

</template>

<script>
    import $ from 'jquery'
    import {KTApp} from '@/plugins/core/app'
    import {settlementService} from '@/common/api.service'
    import {i18n} from '@/plugins/i18n'
    import {statusStr} from '@/constants/settlementStatus'
    import {settlementStatus} from "@/constants/settlementStatus";

    export default {
        props: {
            form_data: {
                required: true,
            }
        },
        computed: {
            can_edit_amount() {
                return (
                    this.form_data.status == 5
                    && this.form_data.details
                    && this.form_data.details.length == 1
                );
            },
        },
        data() {
            return {
                statuses: [
                    {
                        id: 0,
                        value: this.$t('settlement.status.pending')
                    },
                    {
                        id: 2,
                        value: this.$t('settlement.status.accepted')
                    },
                    {
                        id: 3,
                        value: this.$t('settlement.status.rejected')
                    },
                    {
                        id: 4,
                        value: this.$t('settlement.status.final_payed')
                    },
                    {
                        id: 5,
                        value: this.$t('settlement.status.partially_payed')
                    },
                ],
            }
        },
        watch: {
            'form_data.status'(to_value) {
                if (to_value == 5 && this.form_data.details.length != 1) {
                    let form = $('#settings_form');
                    this.showMsg(form, 'danger', i18n.t('message.partial_settlement_is_only_available_on_single_detail_settlements'));
                }
            },
        },
        methods: {
            edit(e) {
                let btn = $('#save_btn');
                let form = $('#manual_settlement');
                form.validate({
                    rules: {
                        tracking_code: {
                            required: () => {
                                return this.form_data.status == 4 || this.form_data.status == 2 ;
                            },

                        },
                    }
                })

                if(!form.valid()) {
                    return
                }
                KTApp.progress(btn);

                let params = {
                    status: this.form_data.status,
                    tracking_code: this.form_data.tracking_code,
                    description: this.form_data.description,
                    amount: this.form_data.amount,
                };

                settlementService.updateSettlement(this.form_data.id, params)
                    .then(() => {
                        this.showMsg(form, 'success', i18n.t('message.changes_submitted_successfully'));
                    })
                    .catch(error => {
                        this.showMsg(form, 'danger', error.response.data.message);
                    })
                    .finally(() => {
                        KTApp.unprogress(btn);
                    });
            },
            changeDetailStatus(detail_id, status) {
                settlementService.changeDetailStatus(detail_id, status).then(response => {
                    this.toastr.success(i18n.t('settlement.change_succeeded'))
                }).catch(({response}) => {
                    this.toastr.fail(i18n.t('settlement.change_failed'))
                })
            },
            getStatusColor(status_int) {
                if (status_int === settlementStatus.CREATED) {
                    return 'color-blue'
                }

                if (status_int === settlementStatus.SENT_TO_SHAPARAK) {
                    return 'color-orange'
                }

                if (status_int === settlementStatus.ACCEPTED || status_int === settlementStatus.FINAL_PAYED) {
                    return 'color-green'
                }

                if (status_int === settlementStatus.REJECTED) {
                    return 'color-red'
                }
            },
            getDetailStatuses(current_status) {
                let statuses = []

                for (let i = 0; i < 5; i++) {
                    if (current_status != i || i !== 1) {
                        statuses.push({
                            int: i,
                            str: statusStr.get(i)
                        })
                    }
                }
                return statuses
            },
            getStatusStr(status_int) {
                return statusStr.get(status_int)
            },
            change_location(id) {
                window.location.assign('../' + id + '/details')
            }
        },
    }
</script>

<style>

</style>